import styled from 'styled-components/macro';

export const Container = styled.div`
  position: fixed;
  z-index: 9999;
  transform: translateX(-50%);
  left: 50%;
  top: 10vh;

  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ isMobile }) =>
    isMobile &&
    `
    top: 20px;`}

  pointer-events: none;
`;

export const SearchButton = styled.div`
  transition: all 0.25s ease-in-out;
  cursor: pointer;
  color: white;
  align-items: center;
  display: flex;

  & svg path {
    box-shadow: 0 0 10px 3px rgb(0 0 0 / 25%);
  }

  font-size: 26px;

  &:hover {
    opacity: 0.9;
  }
  &:active {
    font-size: 25px;
  }
`;

export const Redirect = styled.div`
  transition: all 0.25s ease-in-out;
  width: 100%;
  display: flex;
  background: white;
  padding: 25px 30px;
  box-sizing: border-box;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;

  & .icon {
    margin-left: 20px;
    color: rgba(0, 0, 0, 0.35);
  }

  & .list-box {
    display: flex;
    align-items: center;
    margin-top: 15px;
    & .list {
      opacity: 0.8;
    }
  }

  & .list {
    opacity: 0.95;
  }

  & .list,
  & .task {
    flex: 1;
    font-weight: bold;

    & > div:first-child {
      opacity: 0.95;
    }

    word-break: break-all;
  }

  ${({ color }) =>
    `
&  .list-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;
    background: ${color};
}
`};

  & .task {
    & .list-box {
      opacity: 0.85;
      width: fit-content;
    }
    & .list {
      font-weight: normal;
      color: white;

      width: fit-content;
      border-radius: 8px;
      padding: 6px 12px;
      background: ${({ color }) => color};
    }
  }

  ${({ color_l2 }) =>
    `
    &:hover, &:active { background: ${color_l2}!important; }
    
  `}

  &:active {
    transform: scale(0.99);
  }
`;

export const SearchBar = styled.div`
  transition: all 0.25s ease-in-out;
  border: 2px solid transparent;
  box-sizing: border-box;
  background: white;
  border-color: rgba(0, 0, 0, 0.25);

  display: flex;
  border-radius: 20px;
  box-shadow: 0px 0px 7px 3px rgb(0 0 0 / 15%);
  padding: 5px;

  ${({ forButton }) =>
    !forButton
      ? `
    width: 30vw;
  @media screen and (max-width: 1071px) {
    width: 45vw;
  }
  @media screen and (max-width: 767px) {
    width: 75vw;
  }
  @media screen and (max-width: 491px) {
    width: 70vw;
  }
    
  `
      : `flex: 1; overflow: hidden; opacity: 1;`}

  ${({ forButton, startSearch }) =>
    forButton &&
    startSearch &&
    `
    opacity: 0;`}

  & .search-input {
    flex: 1;
    border: none;
    padding: 0 5px;
    overflow: hidden;
  }

  & .search-icon,
  & .search-clear {
    width: 25px;
    height: 25px;
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    color: rgba(0, 0, 0, 0.25);
  }

  & .search-clear {
    transition: all 0.15s ease-in-out;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.5);
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const LinkButton = styled.div`
  transition: all 0.15s ease-in-out;
  color: white;
  text-decoration: underline;
  cursor: pointer;
  opacity: 0.6;

  &:hover {
    opacity: 0.45;
  }
`;

export const ResultBox = styled.div`
  background: linear-gradient(
    281.96deg,
    rgba(225, 225, 234, 0.53) 4.21%,
    rgba(225, 225, 234, 0.3) 98.56%
  );
  backdrop-filter: blur(3px);
  padding: 16px;
  display: flex;

  box-shadow: 0px 0px 10px 5px rgb(0 0 0 / 25%);

  @media screen and (max-width: 1071px) {
    max-width: 80vw !important;
    min-width: 70vw !important;
  }

  @media screen and (max-width: 767px) {
    padding: 12px;
    width: 80vw;
  }
`;
